import { contact } from "../../../api/contact.api";

export const Contact = {
  state: {
    contact: {
      name: null,
      email: null,
      company: null,
      whatsapp: null,
      message: null,
    },
    success: false,
  },

  mutations: {
    SET_FORM_DATA(state, { name, email, company, whatsapp, message }) {
      state.contact.name = name;
      state.contact.email = email;
      state.contact.company = company;
      if (whatsapp !== undefined) state.contact.whatsapp = whatsapp;
      state.contact.message = message;
    },
  },

  actions: {
    async submitForm({ state, commit }, payload) {
      try {
        const { data } = await contact(payload);
        state.success = data.success;
        commit("SET_FORM_DATA", data);
      } catch (error) {
        console.log(error);
      }
    },
  },
  getters: {},
  namespaced: true,
};
